module.exports = ".manage-jobs-sec > table >tbody> td {\n\tpadding: 10px 0px !important;\n}"